const STORAGE_KEY = 'merchant_last_routes';

export const getMerchantLastRoutes = () => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (error) {
        return {};
    }
};

export const getMerchantLastRoute = (merchantCode) => {
    const routes = getMerchantLastRoutes();
    return routes[merchantCode] || null;
};

export const setMerchantLastRoute = (merchantCode, path) => {
    if (!merchantCode || !path) return;

    const routes = getMerchantLastRoutes();
    routes[merchantCode] = path;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(routes));
};